<template>
    <div class="card course-enrollment-form">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h5 style="line-height: 40px;">Formulário de inscrição</h5>
                <div class="card-header-pills" v-show="step < 5">
                    <ul class="nav nav-pills">
                        <li class="nav-item step">
                            <a href="#" class="nav-link" :class="{'active': step === 1}" @click.prevent="goToStep(1)">1</a>
                        </li>
                        <li class="nav-item step">
                            <a href="#" class="nav-link" :class="{'active': step === 2}" @click.prevent="goToStep(2)">2</a>
                        </li>
                        <li class="nav-item step">
                            <a href="#" class="nav-link" :class="{'active': step === 3}" @click.prevent="goToStep(3)">3</a>
                        </li>
                        <li class="nav-item step">
                            <a href="#" class="nav-link" :class="{'active': step === 4}" @click.prevent="goToStep(4)">4</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="card-body">

            <loading-feedback :active="isLoading" text="Enviando dados..." :overlay="true"></loading-feedback>

            <div class="step step-1" v-show="step === 1">

              <form id="step-1-enrollment-form">

                <div class="form-group">
                      <label for="chk-is_public_school-yes">O aluno é estudante de Escola Pública?</label>
                      <div>
                          <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" v-model="enrollment.is_public_school" id="chk-is_public_school-yes" :value="1">
                              <label class="form-check-label" for="chk-is_public_school-yes">Sim</label>
                          </div>
                          <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" v-model="enrollment.is_public_school" id="chk-is_public_school-no" :value="0">
                              <label class="form-check-label" for="chk-is_public_school-no">Não</label>
                          </div>
                      </div>
                  </div>

                <div class="form-group">
                    <label for="fld-period_enrolled">Período desejado</label>
                    <select id="fld-period_enrolled" required class="form-control" v-model="enrollment.period_enrolled">
                        <option v-for="period in course.periods" :value="period" v-text="$lang.get('course.periods.' + period)"></option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="fld-dob">Data de nascimento do aluno</label>
                    <input id="fld-dob" required class="form-control" v-model="enrollment.dob" type="date" />
                </div>

                <div v-if="isStudentEligible === false">
                    <div class="alert alert-danger">
                        <p>Agradecemos ao seu interesse em participar dos cursos oferecidos pelo Instituto Eurofarma, mas a sua inscrição não pode ser efetivada.</p>
                        <p>O primeiro requisito para a inscrição é ser, ou ter sido, estudante de escola pública, além de atender aos critérios de faixa etária por curso.</p>
                    </div>
                </div>
              </form>

            </div>

            <div class="step step-2" v-show="step === 2">

              <form id="step-2-enrollment-form">
                <div class="row">

                    <div class="form-group col-md-9">
                        <label for="fld-name">Nome completo do aluno</label>
                        <input id="fld-name" required class="form-control" v-model="enrollment.name" type="text" />
                    </div>

                    <div class="form-group col-md-3">
                        <label for="fld-gender">Sexo</label>
                        <select id="fld-gender" required class="form-control" v-model="enrollment.gender">
                            <option v-for="gender in options.genders" :value="gender" v-text="gender"></option>
                        </select>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-cpf">CPF do aluno</label>
                        <input id="fld-cpf" pattern=".{14,}" v-mask="masks.CPF" required class="form-control" v-model="enrollment.cpf" type="text" title="Preencha um CPF válido, ex: 222.333.444-55" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-email">E-mail do aluno</label>
                        <input id="fld-email" required class="form-control" v-model="enrollment.email" type="email" />
                    </div>

                    <hr />

                    <div class="form-group col-md-6">
                        <label for="fld-rg">RG do aluno</label>
                        <input id="fld-rg" required class="form-control" v-model="enrollment.rg" type="tel" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-rg_expedicao">Data de Expedição</label>
                        <b-form-datepicker
                            v-model="enrollment.rg_expedicao"
                            :required="true"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        ></b-form-datepicker>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-rg_orgao">Órgão Expeditor</label>
                        <input id="fld-rg_orgao" required class="form-control" v-model="enrollment.rg_orgao" type="text" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-rg_uf">UF de Expedição</label>
                        <select id="fld-rg_uf" required class="form-control" v-model="enrollment.rg_uf">
                            <option v-for="uf in options.ufs" :value="uf" v-text="uf"></option>
                        </select>
                    </div>

                    <hr />

                    <div class="form-group col-md-6">
                        <label for="fld-phone">Celular do Aluno com WhatsApp</label>
                        <input id="fld-phone" pattern=".{15,}" required v-mask="masks.CellphoneWithDDD" class="form-control" v-model="enrollment.phone" type="tel" title="Preencha um número de celular válido, com DDD; ex: (11) 93333-4444" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-civil_status">Estado Civil</label>
                        <select id="fld-civil_status" required class="form-control" v-model="enrollment.civil_status">
                            <option v-for="status in options.civil_statuses" :value="status" v-text="status"></option>
                        </select>
                    </div>

                    <hr />

                    <div class="form-group col-md-9">
                        <label for="fld-address_address">Endereço</label>
                        <input id="fld-address_address" required class="form-control" v-model="enrollment.address_address" type="text" />
                    </div>

                    <div class="form-group col-md-3">
                        <label for="fld-address_number">Número</label>
                        <input id="fld-address_number" required class="form-control" v-model="enrollment.address_number" type="text" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-address_complement">Complemento</label>
                        <input id="fld-address_complement" class="form-control" v-model="enrollment.address_complement" type="text" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-address_neighborhood">Bairro</label>
                        <input id="fld-address_neighborhood" required class="form-control" v-model="enrollment.address_neighborhood" type="text" />
                    </div>

                    <div class="form-group col-md-3">
                        <label for="fld-address_cep">CEP</label>
                        <input id="fld-address_cep" pattern=".{9,}" required name="address_cep" v-mask="masks.CEP" class="form-control" v-model="enrollment.address_cep" type="tel" title="Preencha um CEP válido, ex: 01234-560" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-address_city">Cidade</label>
                        <input id="fld-address_city" required class="form-control" v-model="enrollment.address_city" type="text" />
                    </div>

                    <div class="form-group col-md-3">
                        <label for="fld-address_uf">UF</label>
                        <select id="fld-address_uf" required class="form-control" v-model="enrollment.address_uf">
                            <option v-for="status in options.ufs" :value="status" v-text="status"></option>
                        </select>
                    </div>

                </div>
              </form>

            </div>

            <div class="step step-3" v-show="step === 3">

              <form id="step-3-enrollment-form">
                <div class="row">

                    <div class="form-group col-md-7">
                        <label for="fld-education_level">Escolaridade</label>
                        <select id="fld-education_level" required class="form-control" v-model="enrollment.education_level">
                            <option v-for="option in options.education_levels" :value="option" v-text="option"></option>
                        </select>
                    </div>

                    <div class="form-group col-md-5">
                        <label for="fld-education_status">Situação atual</label>
                        <select id="fld-education_status" required class="form-control" v-model="enrollment.education_status">
                            <option v-for="option in options.education_statuses" :value="option" v-text="option"></option>
                        </select>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-education_serie">Série</label>
                        <select id="fld-education_serie" required class="form-control" v-model="enrollment.education_serie">
                            <option v-for="option in options.education_series" :value="option" v-text="option"></option>
                        </select>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-school_name">Escola / Instituição</label>
                        <input id="fld-school_name" required class="form-control" v-model="enrollment.school_name" type="text" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="chk-has_handicap-yes">Portador de deficiência?</label>
                        <div>
                            <div class="form-check form-check-inline">
                                <input required class="form-check-input" name="has_handicap" type="radio" v-model="enrollment.has_handicap" id="chk-has_handicap-yes" :value="1">
                                <label class="form-check-label" for="chk-has_handicap-yes">Sim</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input required class="form-check-input" name="has_handicap" type="radio" v-model="enrollment.has_handicap" id="chk-has_handicap-no" :value="0">
                                <label class="form-check-label" for="chk-has_handicap-no">Não</label>
                            </div>
                        </div>
                    </div>

                    <div class="form-group col-md-6">
                        <div v-if="enrollment.has_handicap">
                            <label for="fld-handicap_name">Qual deficiência?</label>
                            <input id="fld-handicap_name" required class="form-control" v-model="enrollment.handicap_name" type="text" />
                        </div>
                    </div>

                    <hr />

                    <input type="text" style="visibility: hidden;" />

                    <div class="form-group col-md-12">
                        <label for="fld-guardian_name">Nome do responsável</label>
                        <input id="fld-guardian_name" class="form-control" v-model="enrollment.guardian_name" type="text" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-guardian_email">E-mail do responsável</label>
                        <input id="fld-guardian_email" class="form-control" v-model="enrollment.guardian_email" type="email" />
                    </div>

                    <div class="form-group col-md-6">
                        <label for="fld-guardian_phone">Telefone do responsável</label>
                        <input id="fld-guardian_phone" pattern=".{14,}" v-mask="masks.CellphoneWithDDD" class="form-control" v-model="enrollment.guardian_phone" type="tel" title="Preencha um número de telefone válido, com DDD; ex: (11) 93333-4444" />
                    </div>

                </div>
              </form>
            </div>

            <div class="step step-4" v-show="step === 4">

              <form id="step-4-enrollment-form">
                <div class="row">

                    <div class="form-group col-md-6">
                        <label for="fld-source">Como conheceu o curso?</label>
                        <select id="fld-source" required class="form-control" v-model="enrollment.source">
                            <option v-for="option in options.sources" :value="option" v-text="option"></option>
                        </select>
                    </div>

                    <div class="form-group col-md-6">
                        <label for="chk-has_relative_at_eurofarma-yes">Possui parentes na Eurofarma?</label>
                        <div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" required name="has_relative_at_eurofarma" v-model="enrollment.has_relative_at_eurofarma" id="chk-has_relative_at_eurofarma-yes" :value="1">
                                <label class="form-check-label" for="chk-has_relative_at_eurofarma-yes">Sim</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" required name="has_relative_at_eurofarma" v-model="enrollment.has_relative_at_eurofarma" id="chk-has_relative_at_eurofarma-no" :value="0">
                                <label class="form-check-label" for="chk-has_relative_at_eurofarma-no">Não</label>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row" v-if="enrollment.has_relative_at_eurofarma">
                    <div class="form-group col-md-12">
                        <label for="fld-relative_name">Nome do parente colaborador</label>
                        <input id="fld-relative_name" required class="form-control" v-model="enrollment.relative_name" type="text" />
                    </div>

                    <div class="form-group col-md-4">
                        <label for="fld-relative_re">R.E. do colaborador (ex: 12.345)</label>
                        <input id="fld-relative_re" required class="form-control" v-model="enrollment.relative_re" type="tel" />
                    </div>

                    <div class="form-group col-md-4">
                        <label for="fld-relative_area">Área do colaborador</label>
                        <input id="fld-relative_area" required class="form-control" v-model="enrollment.relative_area" type="text" />
                    </div>

                    <div class="form-group col-md-4">
                        <label for="fld-relative_relationship">Grau de parentesco</label>
                        <input id="fld-relative_relationship" required class="form-control" v-model="enrollment.relative_relationship" type="text" />
                    </div>

                    <div v-if="message" class="alert alert-warning">{{message}}</div>
                </div>

                <div class="row">

                  <div class="form-group col-md-12">
                    <label for="fld-monthly_revenue">Qual é a soma de todos os salários das pessoas que moram com você (incluindo você)?</label>
                    <money id="fld-monthly_revenue" v-bind="masks.currency" maxlength="14" v-model="enrollment.monthly_revenue" class="form-control" />
                  </div>

                  <div class="form-group col-md-12">
                    <label for="fld-people_in_house">Quantas pessoas vivem em sua casa, incluindo você?</label>
                    <input id="fld-people_in_house" required class="form-control" v-model="enrollment.people_in_house" max="30" type="number" />
                  </div>

                  <div class="form-group col-md-12">
                    <label for="fld-completed_courses">De quais cursos ou eventos você já participou no Instituto Eurofarma ou na sua escola?</label>
                    <b-form-checkbox-group :required="true" class="completed_courses-block" v-model="enrollment.completed_courses" name="check-button" @change="$forceUpdate();">
                      <b-form-checkbox v-for="option in options.courses" :key="option" :value="option">{{ option }}</b-form-checkbox>
                    </b-form-checkbox-group>
                  </div>

                  <div class="form-group col-md-12 course-completed-selector">
                    <label for="fld-date_conclusions">Em que mês e ano você concluiu cada um dos cursos dos quais participou?</label>
                    <b-input-group :required="true" class="mb-3" v-for="course in enrollment.completed_courses" :key="course" :prepend="course"  v-if="course !== options.courses[0]">
                      <input required class="form-control" v-model="enrollment.date_conclusions[course]" type="date" v-if="enrollment.date_conclusions[course] !== 'Não terminei o curso'"/>
                      <template #append>
                        <b-form-checkbox v-model="enrollment.date_conclusions[course]" name="enrollment_courses" value="Não terminei o curso">Não terminei o curso</b-form-checkbox>
                      </template>
                    </b-input-group>
                  </div>
                </div>
              </form>
            </div>

            <div class="step step-5 completed" v-show="step === 5">

                <div class="alert alert-success" v-if="sendError === null">
                    <strong>Sua inscrição foi enviada com sucesso!</strong><br />
                    Código da inscrição: {{enrollmentCode}}
                </div>

                <div class="alert alert-warning" v-if="sendError !== null">
                    <span v-text="sendError"></span>
                </div>
            </div>

        </div>

        <div class="card-footer" v-if="isStudentEligible === true && step !== 5">
            <div class="d-flex justify-content-end">
                <button type="button" v-if="step !== 1" @click="step = step - 1" class="btn btn-secondary">&laquo; Voltar</button>
                <button type="button" @click="nextStep" class="btn btn-primary ml-2">
                  <span v-html="step !== 4 ? 'Próximo &raquo;' : 'Submeter inscrição'"></span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import Masks from '../services/Masks';
    import Courses from "../services/Courses";
    import {DateTime} from 'luxon';
    import {Money} from 'v-money';

    export default {
        components: {Money, FormValidationCtrl},
        props: ['course', 'options'],
        data: () => { return {
            step: 1,
            doneSteps: [],
            masks: Masks,
            isLoading: false,
            birthdateValidation: null,
            message: null,
            errors: [],
            enrollmentCode: null,
            sendError: null,
            enrollment: {
              completed_courses: [],
              date_conclusions: {}
            },
        }},
        mounted() {

        },
        computed: {
            isStudentEligible() {
                if (this.enrollment.is_public_school === 0) {
                    return false;
                }

                if (this.enrollment.is_public_school == null) {
                    return null;
                }

                if (this.enrollment.period_enrolled == null) {
                    return null;
                }

                if (this.enrollment.dob == null) {
                    return null;
                }

                if (this.enrollment.dob.length < 10) {
                    return null;
                }

                try {
                    let date = DateTime.fromFormat(this.enrollment.dob, 'yyyy-MM-dd');
                    let age = 0 - date.diffNow('years').get('years');

                    if (age < this.course.age_min || age > this.course.age_max + 0.9999) {
                        return false
                    }

                } catch (err) {
                    console.warn("Date error: ", err);
                    return null
                }

                return true;
            }
        },
        methods: {
            nextStep(ev) {
                ev.preventDefault();

                let stepForm = document.getElementById('step-' + this.step + '-enrollment-form');

                this.birthdateValidation = true
                if (this.step === 1 && this.enrollment.dob === null) {
                  this.birthdateValidation = false
                }

                if (!FormValidationCtrl.default.methods.formIsValid(stepForm)) {
                  return;
                }

                if (this.step === 4) {
                    this.submitEnrollment();
                    return;
                }

                if (this.doneSteps.indexOf(this.step) === -1) {
                    this.doneSteps.push(this.step);
                }

                this.step++;

                this.$nextTick(() => this.$forceUpdate());
            },
            submitEnrollment() {
                this.isLoading = true;
                this.message = null;
                this.errors = [];

                let enrollment = Object.assign({}, this.enrollment);
                    enrollment.cpf = enrollment.cpf.replace(/\D/g,'');
                    enrollment.address_cep = enrollment.address_cep.replace(/\D/g,'');
                    enrollment.phone = enrollment.phone.replace(/\D/g,'');
                    enrollment.country = 'Brasil';

                Courses.SubmitEnrollment(this.course.id, enrollment)
                    .then((data) => {
                        console.log("Enrollment completed: ", data);
                        this.isLoading = false;
                        this.step = 5;

                        if (data.status === 'failed') {
                            this.sendError = data.message
                            return
                        }

                        this.enrollmentCode = data.enrollment_code;
                    })
                    .catch ((err) => {
                        console.error("Failed to enroll: ", err, err.response);

                        this.isLoading = false;
                        this.message = err.response.data.message;
                        this.errors = err.response.data.errors;
                    })
            },
            goToStep(step) {
                if (this.doneSteps.indexOf(step) === -1) {
                    return;
                }

                this.step = step;
            },
        },
    }
</script>
